import { render, staticRenderFns } from "./UploadedData.vue?vue&type=template&id=a8596edc"
import script from "./UploadedData.vue?vue&type=script&lang=js"
export * from "./UploadedData.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports